import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Grid, IconButton, MenuItem, Select, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import UpdateOrder from "../UpdateOrder";
import { orderApi, updateOrderApi } from "store/api";
import OrderList from "../OrderList";
import Success from "components/Success";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function OrderTab() {
  const [msg, setMsg] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [orders, setOrders] = React.useState([]);
  const [updateOrder, setUpdateOrder] = React.useState({});
  const [errors, setErrors] = React.useState({});

  const handleClickOpenUpdate = data => {
    setUpdateOrder(data);
    setErrors({});
    setOpenUpdate(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdate(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const FetchOrder = async searchTerm => {
    const params = !searchTerm
      ? {}
      : {
        keyword: searchTerm,
      };
    try {
      const response = await orderApi(params);
      if (response?.success) {
        setOrders(response?.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [debounceTimeout, setDebounceTimeout] = React.useState(null);

  const handleChangeOrder = async e => {
    const { value } = e.target;
    if (debounceTimeout) clearTimeout(debounceTimeout);
    const newTimeout = setTimeout(() => {
      FetchOrder(value);
    }, 500);

    setDebounceTimeout(newTimeout);
  };

  const handleSubmitUpdate = async e => {
    e?.preventDefault();
    if (updateOrder.deliveryType !== 'pick-up') {
      if (!updateOrder.trackingNumber) {
        setErrors({ trackingNumber: "Tracking number is required." });
        return;
      }
      if (updateOrder.trackingNumber.length !== 14) {
        setErrors({ trackingNumber: "Tracking number must be exactly 14 digits." });
        return;
      }
    }
    setErrors({});
    let apiData = {
      orderId: updateOrder.orderId,
      deliveryStatus: updateOrder.deliveryStatus,
      transactionStatus: updateOrder.transactionStatus,
      trackingNumber: updateOrder.deliveryType === 'pick-up' ? null : updateOrder.trackingNumber,
    };
    const response = await updateOrderApi(apiData);
    if (response?.success) {
      setMsg("Update order status successfully");
      setSuccess(true);
      setOpen(true);
      FetchOrder();
      handleCloseUpdate();
    } else {
      setSuccess(false);
      setMsg(response?.message || "Something went wrong. Please try again later.");
      setOpen(true);
    }
  };
  const handleChangeUpdateOrder = e => {
    const { name, value } = e.target;
    if (name === 'trackingNumber') {
      setErrors(prev => ({ ...prev, trackingNumber: null }));
    }
    setUpdateOrder(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  React.useEffect(() => {
    FetchOrder();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        marginTop: "20px",
        marginBottom: "30px",
        backgroundColor: "",
        border: "",
        borderRadius: "12px",
        boxShadow: "0 0 8px 1px rgba(0,0,0,0.25)",
        color: "",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <Typography variant='h5'>Orders</Typography>

        <TextField
          placeholder='Search here...'
          InputProps={{
            endAdornment: (
              <IconButton color='inherit'>
                <Search />
              </IconButton>
            ),
          }}
          onChange={handleChangeOrder}
          style={{ backgroundColor: "", borderRadius: "4px" }}
        />
      </div>

      <Box>
        <AppBar position='static'>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor='secondary'
            textColor='inherit'
            variant='fullWidth'
            aria-label='full width tabs example'
          >
            <Tab label='All' {...a11yProps(0)} />
            {/* <Tab label='Ordered' {...a11yProps(1)} /> */}
            <Tab label='Processing' {...a11yProps(2)} />
            <Tab label='Canceled' {...a11yProps(3)} />
            <Tab label='Shipping' {...a11yProps(4)} />
            <Tab label='Delivered' {...a11yProps(5)} />
            <Tab label='Picked up' {...a11yProps(6)} />
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={0} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        {/* <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={1} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel> */}
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={2} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={3} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={3} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={4} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={4} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={5} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={5} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={6} dir={theme.direction}>
          <Grid container py={3} spacing={3}>
            {orders?.length == 0 && <div>No Order found</div>}
            {orders?.length > 0 && (
              <OrderList orders={orders} active={6} handleClickOpenUpdate={handleClickOpenUpdate} />
            )}
          </Grid>
        </TabPanel>
      </Box>
      <UpdateOrder
        open={openUpdate}
        handleClose={handleCloseUpdate}
        handleSubmit={handleSubmitUpdate}
        updateOrderData={updateOrder}
        handleChangeUpdateOrder={handleChangeUpdateOrder}
        errors={errors}
      />
      <Success open={open} success={success} msg={msg} handleClose={handleClose} />
    </div>
  );
}
